import React from 'react'

import './InputDefault.css'

const InputDefault = ({ placeholder, type, onChange, onKeyDown }) => {
    return (
        <input className='input-default'
            type={type}
            placeholder={placeholder}
            onChange={onChange}
            onKeyDown={onKeyDown} />
    )
}

export default InputDefault